import { render, staticRenderFns } from "./LeaseSignature.vue?vue&type=template&id=a8dc124e"
import script from "./LeaseSignature.vue?vue&type=script&lang=ts"
export * from "./LeaseSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports